import * as api from 'api'

import { AppThunk } from 'redux/store'
import { showsReceived } from '.'
import { isFailure, ApiResult } from 'data/ApiResult'
import { handleApiError } from 'redux/slices/error'
import { Show } from 'data/Show'
import { SHOW_SCOPE_PUBLIC } from 'constants.js'

export const retrieveShows = (showsPromise: ApiResult<Show[]>): AppThunk => async dispatch => {
    const result = await showsPromise

    if (isFailure(result)) {
        return dispatch(handleApiError(result))
    }

    dispatch(showsReceived(result.data))
}

export const fetchShows = (): AppThunk => async dispatch => {
    dispatch(retrieveShows(await api.getShows({ params: { scope: SHOW_SCOPE_PUBLIC, isPublished: true } })))
}

export const fetchShowsBySeriesId = (seriesId: string): AppThunk => async dispatch => {
    dispatch(retrieveShows(await api.getShowsBySeriesId(seriesId)))
}
